export default __webpack_public_path__ + "img/pencil-circle.9e689ae4.svg";